import { IoCheckmark, IoChevronBack, IoClose } from "react-icons/io5";
import { useState, useEffect,useRef,useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PayjpCheckout from 'react-payjp-checkout';
import { Post, PostFile } from '../compornents/Post';
import { toast } from 'react-toastify';
import { Map, Marker } from '@vis.gl/react-google-maps';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics,Gtag,FacebookPixel,Linetag,isInAppBrowser } from '../compornents/Analytics';
import { CalcGoukei,ConfirmOrder,uberFee,uberFeeNormal } from "../compornents/CalcGoukei";
import { BAG_FIRST } from "../bagFirst";
import { rateChangePhase, RATE_CHANGE_NOTICE_PATH } from "../rateChange";
import "../css/SelfGuide.css";
import { spotSelfAtStore } from '../selfDropoff';
import { ClosetPicker, canPickCloset } from '../compornents/ClosetPicker';

export const Confirm = () => {
  // console.log('Confirm');
  const navigate = useNavigate();
  const [isAgree, setIsAgree] = useState(false);
  let location = useLocation();
  let [data, setData] = useState(location.state.data);
  // console.log(data);
  let [syoukei, setSyoukei] = useState(0);
  let [goukei, setGoukei] = useState(0);
  const [isCreditError, setIsCreditError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  let [orderCreateErrorTxt, setOrderCreateErrorTxt] = useState(null);
  let [orderCreateErrorCode, setOrderCreateErrorCode] = useState(null);
  const isFirstRender = useRef(true);
  const [closetReload, setClosetReload] = useState(0); // 注文で服の状態が変わったと言われたら一覧を読み直す

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  const options = {
    disableDefaultUI: true,
    // デフォルトUI（衛星写真オプションなど）をキャンセルします。
    zoomControl: false,
    clickableIcons: false
  };
  // クーポンクリア
  const clearCoupon = () => {
    // data.coupon = undefined;
    data.coupon = undefined;
    try { sessionStorage.removeItem('lp_selected_coupon'); } catch (e) {}
    setData(data);
    calcGoukei();
  }
  // 戻る
  const back = () => {
    // console.log(data.item.type);
    if (data.item.type === 'bag') {
      navigate("/home");
    }else if (data.item.type === 'futon_bag' || data.item.type === 'futon') {
      navigate("/menu_detail", { state: { data: data } });
    }else if (data.item.type === 'tsuika') {
      navigate("/notification/" + data.notification.id);
    }else{
      navigate("/option_category", { state: { data:data } });
    }
  };

  // ホームへ
  const toHome = () => {
    if(data.item.type === 'tsuika'){
      navigate("/notifications");
    }else{
      navigate("/home");
    }
  };
  // 利用規約に同意してください
  const requestAgree = () => {
    if(isAgree===false){
      toast.error('利用規約に同意してください');
    }else if(data.customer?.card_type==null){
      toast.error('クレジットカードを登録してください');
      setIsCreditError(true);
    }
  }
  // クレジットカード登録
  async function createCredit() {
    // 見積もり取得
    let payjp_token = document.getElementsByName('create_order_payjp_token')[0].value;
    const request_data = { payjp_token: payjp_token };
    const response_data = await Post('post', '/customer/create_credit.php', request_data);
    // console.log(payjp_token);
    if (response_data.result === 1) {
      Gtag('create_credit_success');
      FacebookPixel('AddPaymentInfo');
      const customer = response_data.customer;
      const newData = { ...data, customer };
      setData(newData);
    } else {
      // エラー
      toast.error(response_data.error_message);
      Gtag('create_credit_failed', {
        error_message: response_data.error_message,
      });
    }
  };
  // クレジットカード変更（削除→登録フォームに戻す）
  async function changeCredit() {
    const response_data = await Post('post', '/customer/delete_credit.php', {});
    if (response_data.result === 1) {
      setData({
        ...data,
        customer: { ...data.customer, card_type: null, expYear: null, expMonth: null, last4: null },
      });
    } else {
      toast.error(response_data.error_message);
    }
  };
  // 注文作成
  async function createOrder() {
    if (isSubmitting) return;
    setIsSubmitting(true);
    openLoadingModal();
    try {
    // console.log('order');
    // オプション
    let option_ids = [];
    let option_suu = [];
    let tmp_option_files = [];
    // console.log(data?.options);
    if (data?.options !== undefined && data?.options.length > 0) {
      data.options.forEach((option) => {
        option_ids.push(option.id);
        option_suu.push(option.suu);
        if (option.images !== undefined) {
          option.images.forEach((image,key) => {
            tmp_option_files.push({ key_name: option.id + '_' + key, file: image.file });
          });
        }
      });
    }
    // クーポン: data.coupon が画面遷移で消えていても sessionStorage から復元し、必ず coupon_id を送る
    let couponForOrder = data.coupon;
    if (!couponForOrder) {
      try {
        const saved = sessionStorage.getItem('lp_selected_coupon');
        if (saved) couponForOrder = JSON.parse(saved);
      } catch (e) {}
    }
    // 注文作成
    const request_data = { item_id: data.item?.id,lpspot_id:data.item?.lpspot?.id ?? data.lpspot?.id, quote_id: data.quote?.id,coupon_id: couponForOrder?.id,option_ids: option_ids,option_suu:option_suu,user_dropoff_type:data?.user_dropoff_type,order_id:data?.order?.id};
    // お気に入りクローゼット（dev）: このバッグに入れる服。撮影割引の額はサーバが決める
    if (canPickCloset(data) && data.closet_items?.length > 0) request_data.closet_item_ids = data.closet_items.map((it) => it.id);
    const response_data = await PostFile('post', '/order/create.php', request_data,tmp_option_files);
    // console.log(response_data);
    // PostFileはE999時に/loginへリダイレクトしundefinedを返すことがある（その場合は何もしない）
    if (!response_data) { return; }
    if (response_data.result === 1) {
      // 注文確定したのでクーポン保持をクリア（次の注文に持ち越さない）
      try { sessionStorage.removeItem('lp_selected_coupon'); } catch (e) {}
      Gtag('order_success', {
        order_id: response_data.order.id,
      });
      Linetag('Conversion');
      Gtag('conversion_event_purchase', {
        order_id: response_data.order.id,
      });
      FacebookPixel('Purchase', { value: + response_data.order.goukei, currency: 'JPY' });
      if (BAG_FIRST && Number(data.quote?.is_bag_first) === 1) {
        // bag-first: この注文の1本目の配達は「専用バッグのお届け」。
        // 「届けた配達員に依頼品を渡す」という誤解を潰す専用の完了画面へ送る。
        navigate("/order_done/" + response_data.order.id);
      } else if (data.item.type==='bag'){
        // 初回注文
        // console.log('専用バッグ注文OK'+response_data.order.id);
        navigate("/home/" + response_data.order.id, { state: { is_first_order: 1 } });
      } else if(Number(data.item.id)===0) {
        // 追加決済
        navigate("/notification/"+data.notification.id);
      } else {
        navigate("/home/" + response_data.order.id, { state: { is_first_order: 0 } });
      }
      if(response_data?.gatag_event!==''){
        Gtag(response_data.gatag_event, {
          order_id: response_data.order.id,
        });
      }
    } else if (response_data.coupon_id_invalid) {
      // 選択中クーポンが無効（使用済み/期限切れ等）→ 解除して再試行を促す（空トースト詰まり防止）
      data.coupon = undefined;
      try { sessionStorage.removeItem('lp_selected_coupon'); } catch (e) {}
      setData({ ...data });
      calcGoukei();
      toast.error('選択中のクーポンが使用できないため解除しました。金額をご確認のうえ、もう一度お試しください。');
      setOrderCreateErrorTxt('クーポンが使用できないため解除しました。');
      Gtag('order_failed', { error_message: 'coupon_id_invalid' });
    } else if (response_data.closet_invalid) {
      // 選んだ服が使えない（別の注文に入った・消した等）→ 一覧を読み直して選び直してもらう
      setClosetReload((n) => n + 1);
      toast.error(response_data.error_message);
      setOrderCreateErrorTxt(response_data.error_message);
      Gtag('order_failed', { error_message: 'closet_invalid' });
    } else {
      // エラー
      toast.error(response_data.error_message);
      setOrderCreateErrorTxt(response_data.error_message);
      // E035(3km超・配達エリア外)ならセルフガイドへの導線を出すためコードも保持
      setOrderCreateErrorCode(response_data.error_code ?? null);
      Gtag('order_failed', {
        error_message: response_data.error_message,
      });
    }
    } catch (e) {
      console.error('createOrder error', e);
      try {
        Post('post', '/common/js_error.php', {
          context: 'createOrder',
          message: String(e && e.message),
          stack: String(e && e.stack),
          app_version: '1.8.3',
          item_type: String(data?.item?.type),
          item_id: String(data?.item?.id),
          has_item_lpspot: !!(data?.item?.lpspot?.id),
          has_data_lpspot: !!(data?.lpspot?.id),
          has_quote: !!(data?.quote?.id),
          has_notification: !!(data?.notification?.id),
          has_order_id: !!(data?.order?.id),
          card_type: String(data?.customer?.card_type),
          goukei: String(goukei),
          url: String(typeof window !== 'undefined' ? window.location.href : ''),
        });
      } catch (_logErr) { /* ignore logging failures */ }
      toast.error('注文処理でエラーが発生しました。もう一度お試しください。');
      setOrderCreateErrorTxt('注文処理でエラーが発生しました。');
      Gtag('order_failed', { error_message: String(e && e.message) });
    } finally {
      closeLoadingModal();
      setIsSubmitting(false);
    }
  };
  const fail = () => {
    toast.error('クレジットカード情報が正しくありません');
    Gtag('credit_failed');
  }

  // PayJPのtest/liveは REACT_APP_PAYJP_TEST で制御（接続先 REACT_APP_IS_DEV とは別管理）。
  // 公開鍵(pk)はバックエンドの秘密鍵(sk)とモードを一致させる必要がある。
  const payjp_is_test = process.env.REACT_APP_PAYJP_TEST !== 'false';
  const payjp_public_key = payjp_is_test
    ? "pk_test_88ed3508dd9a23c2c538aa38"
    : "pk_live_fa0603bf01da67561383016d";
  const payjpCheckoutProps = {
    dataKey: payjp_public_key,
    dataText: '新規クレジットカード登録',
    dataPartial: 'true',
    dataSubmitText: '保存する',
    dataTokenName: 'create_order_payjp_token',
    dataPayjpThreeDSecure: payjp_is_test ? 'false' : 'true',
    dataPayjpThreeDSecureWorkflow: 'subwindow',
    dataPayjpExtraAttributePhone: 'true',
    onCreatedHandler: createCredit,
    onFailedHandler: fail,
  }
  // ... (other imports remain unchanged)

  const changeUserDropoffType = (user_dropoff_type) => {
    const newData = { ...data, user_dropoff_type };
    setData(newData);
    // console.log(newData.user_dropoff_type);
  };

  const calcGoukei = CalcGoukei(data, setSyoukei, setGoukei);
  // bag-first(初回): この注文の最初のUber便は「集荷」ではなく専用バッグの「お届け」。
  // 集荷系の文言のまま出すと、バッグを届けに来た配達員へ依頼品を渡してしまう誤解を
  // 招くため（2026-09-01 実機指摘）、受け渡しカード・日時・住所の見出しを出し分ける。
  const bagFirstOrder = BAG_FIRST && Number(data?.quote?.is_bag_first) === 1;
  // 3km超ガード(2026-10-01改定): quote.uber_unavailable=1 なら配達(Uber)は選べない。
  // can_user_dropoff_locker はレガシー(文字列)/D1(数値)の両方に耐えるよう Number で判定。
  const uberUnavailable = Number(data?.quote?.uber_unavailable) === 1;
  const canSelfDropoff = Number(data?.lpspot?.can_user_dropoff_locker ?? data?.item?.lpspot?.can_user_dropoff_locker) === 1;
  // セルフを店頭で受け付ける拠点（#613・船堀店など）は、ロッカー商品でもセルフの案内を「店舗」にする
  const selfAtStore = Number(data?.item?.is_dropoff_box) === 0 || spotSelfAtStore(data?.lpspot ?? data?.item?.lpspot);
  const isBagOrder = data?.item?.type === 'bag' || data?.item?.type === 'futon_bag';
  // バッグお届けを含む注文(bag/futon_bag/bag-first)・セルフ不可拠点は代替が無い → 注文不可
  // （API側もE035で弾く二重ガード）
  const uberBlockedOrder = uberUnavailable && (isBagOrder || bagFirstOrder || !canSelfDropoff);
  const couponRef = useRef(null);
  const couponSecRef = useRef(null); // クーポン節（戻り時のスクロール先）
  const scrollToLocker = useCallback((to) => {
    if(to==='rule'){
      couponRef.current?.scrollIntoView({ behavior: 'auto' });
    }else if(to==='coupon'){
      // 戻り時にクーポン節がレンダリングされるのを待ってからスクロール。
      setTimeout(() => couponSecRef.current?.scrollIntoView({ behavior: 'auto', block: 'center' }), 80);
    }
  }, []);

  useEffect(() => {
    // ページトップ
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if(location.state?.from === "rule" ){
        scrollToLocker('rule');
      }else if(location.state?.from === "coupon" ){
        scrollToLocker('coupon');
      }else{
        setTimeout(() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scrollTo(0, 0); // 念のため併用
        }, 1);
      }
    }
    Gtag('view_confirm');
    if (location.state === null || location.state.data === undefined) {
      // console.log('state is null');
      navigate("/home");
    }
    // 合計金額計算
    calcGoukei();
  }, [calcGoukei, location, navigate, setData, data, scrollToLocker]);

  // 安全策: 注文データに顧客情報が無い場合は取得して補完（地図・カード欄の描画/決済に必須）
  useEffect(() => {
    if (data && !data.customer) {
      (async () => {
        const res = await Post('post', '/customer/index.php', {});
        if (res && res.result === 1 && res.customer) {
          setData((prev) => ({ ...prev, customer: res.customer }));
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 3km超(配達対象外)のとき、初期選択が'uber'ならセルフ('own')に自動で切り替える
  // （ItemMenu/RegisterProfile が user_dropoff_type:'uber' 固定で遷移してくるため）。
  // bag-first注文はセルフ不可なので切り替えない（注文自体を uberBlockedOrder で止める）。
  useEffect(() => {
    if (uberUnavailable && !isBagOrder && !bagFirstOrder && canSelfDropoff && data?.user_dropoff_type === 'uber') {
      setData((prev) => ({ ...prev, user_dropoff_type: 'own' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uberUnavailable, canSelfDropoff, isBagOrder, bagFirstOrder, data?.user_dropoff_type]);

  // クーポン復元: 商品/オプションを選び直して data が作り直されても、選択中クーポンを保持する
  // （クーポンは data.coupon=メモリ状態のみで消えやすいため sessionStorage を真実源にする）
  const couponHydratedRef = useRef(false);
  useEffect(() => {
    if (couponHydratedRef.current) return;
    if (data && data.coupon === undefined) {
      try {
        const saved = sessionStorage.getItem('lp_selected_coupon');
        if (saved) {
          const cp = JSON.parse(saved);
          if (cp && cp.id) {
            couponHydratedRef.current = true;
            setData((prev) => ({ ...prev, coupon: cp }));
          }
        }
      } catch (e) {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="App">
      <div className="Confirm">
        <Analytics title="注文確認" />
        <div className="toolbar">
          <div className="toolbar_left">
            <div className="">
              <IoChevronBack onClick={back} />
            </div>
          </div>
          <div className="toolbar_center">
            注文内容の確認
          </div>
          <div className="toolbar_right">
            <IoClose onClick={toHome} />
          </div>
        </div>
        {/* bag-first(2026-09-01): 決済前に「この注文で最初に届くのはバッグ」と必ず読ませる。
            ここを読み飛ばすと、バッグを届けた配達員に依頼品を渡そうとして必ず躓く。 */}
        {BAG_FIRST && Number(data.quote?.is_bag_first) === 1 && (
          <div className="m-3">
            <div className="bf-callout">
              <b>大切なご案内</b>
              専用バッグがまだお手元にないため、<u>まずはバッグを無料でお届けします</u>。
              バッグ到着後、依頼品を入れてからアプリで集荷をご依頼ください。
            </div>
          </div>
        )}
        <div className="">
          {data.item.type === 'tsuika' || Number(data.item.id)===0 ? (
            <></>
          ):data.item.type === 'bag' || data.item.type==='futon_bag'? (
            <div className="">
              {uberUnavailable && (
                <div className="content">
                  <div className="sg-callout">
                    <b>配達エリア外のためご注文いただけません</b>
                    ご登録の住所が拠点から3kmを超えているため、Uber配達（専用バッグのお届け・集荷）はご利用いただけません。ロッカー・店頭でのセルフ対応については<Link to="/self_guide">こちら</Link>をご覧ください。
                  </div>
                </div>
              )}
              <div className="title">
                {data.item.type==='futon_bag' && ('ふとん')}専用バッグお届け日時(予定)
              </div>
              <div className="content">
                {data.quote?.in_business_hours === true ? (
                  <div>
                    <div>
                      およそ<strong className="text-primary">15分〜60分</strong>でお届け可能
                    </div>
                    <div className="th5" style={{ whiteSpace: 'pre-line' }}>
                      受付時間：{data.quote?.business_hours_txt}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="text-danger mb-2 h6">
                      申し訳ございません。現在は受付時間外のため注文できません。受付時間内に再度お試しください
                    </div>
                    <div className="h5" style={{ whiteSpace: 'pre-line' }}>
                      受付時間：{data.quote?.business_hours_txt}
                    </div>
                  </div>
                )}
              </div>
              <div className="title">
                お届け先<span className="text-danger">（ピンの位置をご確認ください）</span>
              </div>
              <div className="content">
                <div className="">
                  {data.customer != null && (
                    <>
                      {data.customer.pref + data.customer.add1 + data.customer.add2 + data.customer.add3 + data.customer.room}
                    </>
                  )}
                </div>
                <div className="mb-3">
                  <Link to="/address" state={{ data: data }}>編集</Link>
                </div>
                <div className="">
                    {data.customer?.lat ? (
                    <div className="w-100 confirmMap">
                      <Map
                        center={{ lat: Number(data.customer.lat), lng: Number(data.customer.lon) }}
                        zoom={18}
                        options={options}
                      >
                        <Marker position={{ lat: Number(data.customer.lat), lng: Number(data.customer.lon) }} />
                      </Map>
                    </div>
                    ) : null}
                </div>
              </div>
            </div>
          ) : (
            <div className="">
              {data.item.type!=='bag' && data.item.type!=='futon_bag' && (
                <>
                  <div className="title">
                    {bagFirstOrder ? '専用バッグのお届けについて' : `${data.item.type === 'futon' ? 'ふとん' : '衣類'}の受け渡し方法をお選びください`}
                  </div>
                  <div className="content">
                    {/* 3km超(10/1改定): 配達対象外の顧客にはUberカードを出さず、セルフ案内を表示 */}
                    {uberUnavailable && (
                      <div className="sg-callout mb-2">
                        <b>配達エリア外のためセルフ対応のみご利用いただけます</b>
                        ご登録の住所が拠点から3kmを超えているため、Uber配達（集荷・お届け）はご利用いただけません。ロッカー・店頭でのお預け・お受け取り（配達手数料無料）は引き続きご利用いただけます。
                        <div className="mt-1">
                          <Link to="/self_guide">はじめてのセルフ利用ガイドを見る</Link>
                        </div>
                      </div>
                    )}
                    {!uberUnavailable && (
                    <button
                      type="button"
                      className={`dropoff-card btn-dropoff ${data?.user_dropoff_type === 'uber' ? 'selected-card-uber' : ''}`}
                      onClick={() => changeUserDropoffType('uber')}
                    >
                      <div className="btn-inner">
                        <div className="check-icon">
                          {data?.user_dropoff_type === 'uber' && <IoCheckmark />}
                        </div>
                        <div className="text-area">
                          <div className="h5">{bagFirstOrder ? '専用バッグをご自宅へお届け' : 'Uberがご自宅まで集荷'}</div>
                          <div>
                            {bagFirstOrder ? <>Uber配達員が専用バッグをお届けします<br /></> : <>Uber配達員がご自宅まで集荷に伺います<br /></>}
                            配達手数料：
                            {uberFee(data) === 0 ?(
                              <><strong>初回無料！</strong>(通常+{uberFeeNormal(data).toLocaleString()}円)</>
                            ):(
                              <>+{uberFee(data).toLocaleString()}円{uberFeeNormal(data) > uberFee(data) ? `(通常+${uberFeeNormal(data).toLocaleString()}円)` : ''}</>
                            )}
                          </div>
                        </div>
                      </div>
                    </button>
                    )}
                    {/* bag-first: 最初の便はお届けであり集荷ではない、を確認画面でも明示する */}
                    {bagFirstOrder && (
                      <div className="text-danger mt-2 h6">
                        ※バッグをお届けする配達員に、依頼品をお渡しすることはできません。<br />
                        バッグ到着後、ホーム画面の「集荷を依頼する」からご依頼ください。
                      </div>
                    )}
                    {/* bag-first は「まず専用バッグをお届け」なので自己持込は選べない
                        （持ち込む専用バッグ自体がまだ無い）。API側でも 'uber' に強制する。 */}
                    {canSelfDropoff && !(BAG_FIRST && Number(data.quote?.is_bag_first) === 1) && (
                      <button
                        type="button"
                        className={`dropoff-card btn-dropoff mt-2 ${data?.user_dropoff_type === 'own' ? 'selected-card-own' : ''}`}
                        onClick={() => changeUserDropoffType('own')}
                      >
                        <div className="btn-inner">
                          <div className="check-icon">
                            {data?.user_dropoff_type === 'own' && <IoCheckmark />}
                          </div>
                          <div className="text-area">
                            <div className="h5">{selfAtStore ? '自分で店舗に持っていく' : '自分でロッカーに預ける'}</div>
                            <div>
                              {selfAtStore ? '指定の店舗に自分で持っていく' : '指定のロッカーに自分で預ける'}<br />
                              配達手数料：なし<br />
                            </div>
                          </div>
                        </div>
                      </button>
                    )}
                    {canSelfDropoff && !bagFirstOrder && (
                      <div className="mt-2" style={{ fontSize: '13px' }}>
                        はじめての方へ：<Link to="/self_guide">セルフ利用の流れ（ロッカー・店頭）はこちら</Link>
                      </div>
                    )}
                  </div>
                </>
              )}
              <div style={{ display: data?.user_dropoff_type === 'own' ? 'block' : 'none' }}>
                {/* セルフの受付可否（見積りの in_business_hours_own。注文確定と同じ判定・#613） */}
                {data.quote?.in_business_hours_own === false && (
                  <div className="text-danger mb-2" style={{ whiteSpace: 'pre-line' }}>
                    現在は受付時間外のため、セルフでのご注文はできません。{'\n'}受付時間：{data.quote?.business_hours_txt_own}
                  </div>
                )}
                <div className="title">
                  {selfAtStore ? '店舗' : 'ロッカー'}お預け期限
                </div>
                <div className="content">
                  {selfAtStore ? (
                    <>
                      {(() => {
                        const limitDate = new Date();
                        limitDate.setDate(limitDate.getDate() + Number(data.lpspot.spot_dropoff_limit_days || 0));
                        const month = limitDate.getMonth() + 1;
                        const day = limitDate.getDate();
                        return (
                          <>
                            ご注文から <strong className="text-danger">{data.lpspot.spot_dropoff_limit_days}日以内</strong>(<strong className="text-danger">{month}月{day}日まで</strong>)に店舗にお持ちください
                          </>
                        );
                      })()}
                    </>
                    ):(
                    <>
                      注文後<strong className="text-danger">{data.lpspot?.locker_dropoff_limit_hours || 24}時間以内</strong>にロッカーに預けてください<br/>
                      期限を過ぎると注文は自動でキャンセルされます
                    </>)}
                </div>
                {selfAtStore && (
                  <>
                    <div className="title">
                      店舗営業時間
                    </div>
                    <div className="content">
                      {data.lpspot?.holiday && (
                        <div>
                          {data.lpspot.holiday}
                        </div>
                      )}
                      {data.lpspot?.business_hours && (
                        <div>
                          {data.lpspot.business_hours}
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div className="title">
                  {selfAtStore ? '店舗' : 'ロッカー'}の位置
                </div>
                <div className="content">
                    {/* 地図だけでは分かりにくいという声（2026-08-20アンケート）を受け、住所を併記 */}
                    {(data.lpspot?.pref) && (
                      <div className="mb-2">
                        〒{data.lpspot?.zip} {data.lpspot?.pref}{data.lpspot?.add1}{data.lpspot?.add2}{data.lpspot?.add3}
                        {(data.lpspot?.lat ?? data.item?.lpspot?.lat) && (
                          <div className="mt-1">
                            <a href={`https://www.google.com/maps/dir/?api=1&destination=${data.lpspot?.lat ?? data.item?.lpspot?.lat},${data.lpspot?.lon ?? data.item?.lpspot?.lon}&travelmode=walking`}
                               target="_blank" rel="noreferrer">🧭 Googleマップでナビを開く</a>
                          </div>
                        )}
                      </div>
                    )}
                    {(data.lpspot?.lat ?? data.item?.lpspot?.lat) ? (
                    <div className="w-100 confirmMap">
                      <Map
                        center={{ lat: Number(data.lpspot?.lat ?? data.item?.lpspot?.lat), lng: Number(data.lpspot?.lon ?? data.item?.lpspot?.lon) }}
                        zoom={15}
                        options={options}
                      >
                        <Marker position={{ lat: Number(data.lpspot?.lat ?? data.item?.lpspot?.lat), lng: Number(data.lpspot?.lon ?? data.item?.lpspot?.lon) }} />
                      </Map>
                    </div>
                    ) : null}
                </div>
                <div className="title">
                  {selfAtStore ? '店舗名' : 'ロッカー名'}
                </div>
                <div className="content">
                  {data.lpspot.name} {selfAtStore ? '' : 'ランドリーパックNow専用ロッカー'}
                </div>
                <div className="title">
                  {selfAtStore ? '店舗' : 'ロッカー'}の外見
                </div>
                <div className="content">
                  <img src={selfAtStore ? data.lpspot.spot_image : data.lpspot.locker_image} className="ItemImage" alt="Item" />
                </div>
              </div>
              <div style={{ display: data?.user_dropoff_type === 'uber' ? 'block' : 'none' }}>
                <div className="title">
                  {bagFirstOrder ? 'バッグのお届け日時(予定)' : '集荷日時(予定)'}
                </div>
                <div className="content">
                {data.quote?.in_business_hours === true ? (
                  <div>
                    <div>
                      およそ<strong className="text-primary">15分〜60分</strong>で{bagFirstOrder ? 'お届け' : '集荷'}可能
                    </div>
                    <div className="th5" style={{ whiteSpace: 'pre-line' }}>
                      受付時間：{data.quote?.business_hours_txt}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="text-danger mb-2 h6">
                      申し訳ございません。現在は受付時間外のため注文できません。受付時間内に再度お試しください
                    </div>
                    <div className="h5" style={{ whiteSpace: 'pre-line' }}>
                      受付時間：{data.quote?.business_hours_txt}
                    </div>
                  </div>
                )}
                </div>
                <div className="title">
                  {bagFirstOrder ? 'バッグのお届け先' : '集荷先'}<span className="text-danger">（ピンの位置をご確認ください）</span>
                </div>
                <div className="content">
                  <div className="">
                    {data.customer != null && (
                      <>
                        {data.customer.pref + data.customer.add1 + data.customer.add2 + data.customer.add3 + data.customer.room}
                      </>
                    )}
                  </div>
                  <div className="mb-3">
                    <Link to="/address" state={{ data: data }}>編集</Link>
                  </div>
                  <div className="">
                      {data.customer?.lat ? (
                      <div className="w-100 confirmMap">
                        <Map
                          center={{ lat: Number(data.customer.lat), lng: Number(data.customer.lon) }}
                          zoom={18}
                          options={options}
                        >
                          <Marker position={{ lat: Number(data.customer.lat), lng: Number(data.customer.lon) }} />
                        </Map>
                      </div>
                      ) : null}
                  </div>
                </div>
              </div>
            </div>
          )}
            {goukei > 0 && data.customer && (
              <>
                <div className="">
                  <div className="title">
                    クレジットカード情報
                  </div>
                  <div className="content">
                    {data.customer.card_type === null ? (
                      <>
                        <div className="mb-2">以下のカード会社に対応しております。</div>
                        <div className="mb-3">
                          <img src="./img/credit_brands.png" alt="step1" className="ItemImage" />
                        </div>
                        <div className="mb-2">
                          {isInAppBrowser() ? (
                            /* LINE等のアプリ内ブラウザでは、カード登録のポップアップと3Dセキュアの別窓が動かないため、外部ブラウザへ誘導する */
                            <div className="alert alert-warning" style={{ fontSize: 13 }}>
                              <div className="mb-2"><strong>LINEなどのアプリ内ブラウザでは、クレジットカード登録（本人認証）ができません。</strong></div>
                              <div className="mb-2">
                                <a href={`${window.location.origin}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}openExternalBrowser=1`} className="btn btn-sm btn-primary">Safari / Chrome で開く</a>
                              </div>
                              <div>開いた先でログインし直し、もう一度ご注文ください。</div>
                            </div>
                          ) : (
                            <PayjpCheckout {...payjpCheckoutProps} />
                          )}
                          {isCreditError === true && (
                            <div className="text-danger mt-2">クレジットカードを登録してください</div>
                          )}
                        </div>
                      </>
                    ):(
                      <div className="mr-2 ml-2">
                          <div className="row">
                            <div className="col-2">
                            </div>
                            <div className="col-5">
                              カード番号
                            </div>
                            <div className="col-5">
                              有効期限
                            </div>
                          </div>
                          <hr/>
                          <div className="row">
                            <div className="col-2 pr-0">
                              {data.customer.card_type==='American Express' ? (
                                <img src="./img/ic/American Express.png" alt="CreditCard" className="ItemImage" />
                              ) : data.customer.card_type==='Diners Club' ? (
                                <img src="./img/ic/Diners Club.png" alt="CreditCard" className="ItemImage" />
                              ) : data.customer.card_type === 'Discover' ? (
                                <img src="./img/ic/Discover.png" alt="CreditCard" className="ItemImage" />
                              ) : data.customer.card_type === 'JCB' ? (
                                <img src="./img/ic/JCB.png" alt="CreditCard" className="ItemImage" />
                              ) : data.customer.card_type === 'MasterCard' ? (
                                <img src="./img/ic/MasterCard.png" alt="CreditCard" className="ItemImage" />
                              ) : data.customer.card_type === 'Visa' && (
                                <img src="./img/ic/Visa.png" alt="CreditCard" className="ItemImage" />
                              )}
                            </div>
                            <div className="col-5 pr-0">
                              **** **** **** {data.customer.last4}
                            </div>
                            <div className="col-3">
                              {data.customer.expMonth}/{data.customer.expYear}
                            </div>
                            <div className="col-2 text-right">
                              <IoCheckmark className="text-primary text-md"/>
                            </div>
                          </div>
                          <div className="text-right mt-2">
                            <span className="text-primary link_deco_none" style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={changeCredit}>
                              カードを変更する
                            </span>
                          </div>
                      </div>
                    )}

                  </div>
                </div>
                </>
            )}
            {canPickCloset(data) && (
              <ClosetPicker data={data} setData={setData} reloadKey={closetReload} />
            )}
            { syoukei > 0 &&  (
              <>
                <div className="" ref={couponSecRef}>
                  <div className="title">
                    クーポン
                  </div>
                  <div className="content">
                    {data.item.is_syokai === '1' ? (
                      <div>
                        新規入会特典はクーポンを使用できません
                      </div>
                    ) : (
                      <div>
                        {data.coupon !== undefined && (
                          <div className="cpn-applied" key={data.coupon.id}>
                            <span className="cpn-spark" aria-hidden="true">✨</span>
                            <div className="cpn-applied-body">
                              <div className="cpn-applied-name">{data.coupon.name}</div>
                              <div className="cpn-applied-amt">-{Number(data.coupon.kingaku || 0).toLocaleString()}円 適用中</div>
                            </div>
                            <Link
                              className="cpn-remove"
                              onClick={(event) => {
                                event.preventDefault(); // ← 画面遷移を防ぐ
                                clearCoupon(); // ← clearCoupon を実行
                              }}
                            >削除</Link>
                          </div>
                        )}
                        {data.coupon === undefined && Number(data.customer?.unused_coupon_qty) > 0 && (
                          <div className="cpn-have">🎟️ 使えるクーポンが {Number(data.customer.unused_coupon_qty)} 枚あります</div>
                        )}
                        <Link to="/coupon" state={{ data: data }} className="cpn-select-btn">
                          {data.coupon !== undefined ? 'クーポンを変更する' : '🎟️ クーポンを選択する'}
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="" ref={couponRef}>
              <div className="title">
                ご注文内容の確認
              </div>
              <div className="content">
                {ConfirmOrder(data, syoukei, goukei,data?.user_dropoff_type)}
                {/* 10/1料金改定の事前注記（9/30まで・JST判定）。10/1以降は表示しない */}
                {rateChangePhase() === 'before' && (
                  <div className="text-left mt-2" style={{ fontSize: 12, color: '#7a4a00' }}>
                    ※10月1日より料金が改定されます（9/30までのご注文は現行料金です）。
                    <Link to={RATE_CHANGE_NOTICE_PATH} style={{ color: '#7a4a00', textDecoration: 'underline' }}>改定内容を見る</Link>
                  </div>
                )}
              </div>
              <div className="explain mb-3">
                <div className="mt-1 mb-3">
                  配達のため、個人情報を委託先の企業に提供する場合がございます。詳細は
                  <Link to="/rule" state={{ data: data }}>利用規約</Link>
                をご確認ください。
                </div>
                <div className="mb-3">
                  <div className="">
                    <input type="checkbox" id="agree" checked={isAgree} onChange={(e) => { setIsAgree(e.target.checked) }} />
                    <label htmlFor="agree">利用規約に同意する</label>
                  </div>
                </div>
                {orderCreateErrorTxt!=null && (
                  <div className="md-3 text-danger">
                    {orderCreateErrorTxt}
                    {orderCreateErrorCode === 'E035' && (
                      <div className="mt-1">
                        <Link to="/self_guide">はじめてのセルフ利用ガイドを見る</Link>
                      </div>
                    )}
                  </div>
                )}
                <div className="mb-3">
                  {uberBlockedOrder ? (
                    <div>
                      <div className="md-3 text-danger mb-2">
                        申し訳ございません。ご登録の住所は配達エリア（拠点から3km）の外のため、{(isBagOrder || bagFirstOrder) ? '専用バッグのお届けを含むこのご注文は承れません。' : 'このご注文は承れません。'}
                        セルフ対応（ロッカー・店頭）については<Link to="/self_guide">こちら</Link>をご覧ください。
                      </div>
                      <button className="btn btn-oval btn-gray-dark form-control" disabled>{(data.item?.type === 'tsuika' || Number(data.item?.id) === 0) ? 'この内容で決済する' : 'この内容で注文する'}</button>
                    </div>
                  ) : isAgree === false || (data.customer.card_type==null && goukei>0) ? (
                    <div>
                      <button className="btn btn-oval btn-gray-dark form-control" onClick={requestAgree}>{(data.item?.type === 'tsuika' || Number(data.item?.id) === 0) ? 'この内容で決済する' : 'この内容で注文する'}</button>
                    </div>
                  ) : (
                    <div>
                      <button className="btn btn-oval btn-yellow form-control" onClick={createOrder}>{(data.item?.type === 'tsuika' || Number(data.item?.id) === 0) ? 'この内容で決済する' : 'この内容で注文する'}</button>
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <button className="btn btn-oval btn-outline-secondary form-control" onClick={back}>戻る</button>
                </div>
              </div>
            </div>
          </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
      </div>

    </div>
  );
}
